export const getRawHomeData = state => state.home.rawHomeData;
export const getMergedHomeData = state => state.home.homepageData;
